// @i18n-ignore-file
export const TAG_PRIORITY = {
  BACK_IN_STOCK_TAG: 'back in stock',
  LOW_STOCK_TAG: 'low stock',
  SOLD_OUT_TAG: 'sold out',
  NEW_TAG: 'new',
  LAST_CHANCE: 'leaving soon',
  PRE_ORDER_TAG: 'preorder',
  PRE_ORDER_TAG_WITH_SPACE: 'pre order',
  BEST_SELLER: 'best seller',
  BUNDLE_TAG: 'bundle and save',
  SALE_TAG: 'save %',
  EARN_CREDIT_TAG: 'earn $',
  APP_EXCLUSIVE_TAG: 'app exclusive',
}
